import { getConfiguration } from "authConfig";
import { PublicClientApplication } from "@azure/msal-browser";

const pca = await PublicClientApplication.createPublicClientApplication(getConfiguration());

async function getToken() {

    // Only acquire token, do not trigger login
    const account = pca.getActiveAccount() || pca.getAllAccounts()[0];
    if (!account) return undefined;
    let accessTokenRequest = {
      scopes: ['openid', 'profile', process.env.REACT_APP_API_SCOPE],
      account: account,
    };
    try {
      return await pca.acquireTokenSilent(accessTokenRequest);
    } catch (err) {
      console.log(err);
      return undefined;
    }
}

async function getTokenRedirect() {
  // Only acquire token via redirect, do not trigger login
  const account = pca.getActiveAccount() || pca.getAllAccounts()[0];
  if (!account) return undefined;
  let accessTokenRequest = {
    scopes: ['openid', 'profile', process.env.REACT_APP_API_SCOPE],
    account: account,
  };
  try {
    return await pca.acquireTokenRedirect(accessTokenRequest);
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export {getToken, getTokenRedirect}